import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { getFeedbackFontFaceRule } from '../utils/get-feedback-font-face-rule';
import FeedbackShellFooter from './feedback-shell-footer';
import FeedbackShellHeader from './feedback-shell-header';

// Card around every feedback screen; the config's brand colour overrides the
// `--feedback-brand` token (feedback.scss keeps the default) and its font is
// applied through a page-scoped @font-face rule.
const FeedbackShell = ({
  title, logoUrl, brandColor, customFont, children,
}) => {
  const fontFaceRule = useMemo(() => getFeedbackFontFaceRule(customFont), [customFont]);

  return (
    <div
      className="feedback-page h-full overflow-y-auto bg-gray-50"
      style={brandColor ? { '--feedback-brand': brandColor } : undefined}
    >
      {fontFaceRule && <style>{fontFaceRule}</style>}
      <div className="flex items-center justify-center min-h-full px-4 py-8">
        <div className="w-full max-w-md bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden">
          <FeedbackShellHeader title={title} logoUrl={logoUrl} brandColor={brandColor} />
          {children}
          <FeedbackShellFooter />
        </div>
      </div>
    </div>
  );
};

FeedbackShell.propTypes = {
  title: PropTypes.string,
  logoUrl: PropTypes.string,
  brandColor: PropTypes.string,
  customFont: PropTypes.shape({
    fontName: PropTypes.string,
    weights: PropTypes.arrayOf(PropTypes.shape({
      weight: PropTypes.number,
      url: PropTypes.string,
    })),
  }),
  children: PropTypes.node.isRequired,
};

FeedbackShell.defaultProps = {
  title: '',
  logoUrl: '',
  brandColor: '',
  customFont: null,
};

export default FeedbackShell;
